let UTILS = require("../libs/utils.js");
var v7811;
var v7812;
var config = require("../config.js");
module.exports = {
  id: "imp",
  name: "Impulsed",
  alias: "imp",
  party: true,
  tag: ["Party", "#ffac00", "#ffb600"],
  endStats: ["sid", "name", "score", "kills", "deaths", "reward"],
  leaderStats: ["score", "kills"],
  forceSpawn: 3,
  forceClass: 0,
  noPickups: true,
  explMlt: 5,
  explSMlt: 2,
  gravMlt: 1.05,
  jumpMlt: 1.5,
  impulseMlt: 3,
  nonObjImpulse: true,
  groundAccel: 2,
  airAccel: 1.4,
  reloadMlt: 0.5,
  frSlid: true,
  wallJ: true,
  wallJM: 100,
  wallJD: 0.05,
  wallJV: 0.06,
  wallJYV: 2,
  noScrLimit: true,
  startingLoadout: [5, 22],
  disabledStreaks: [4, 5, 6],
  preventCustomGames: true,
  onKill: function (p9342, p9343, p9344, p9345) {
    if (p9345 && p9345 != p9344 && !p9345.canThrow) {
      p9342.refillPlayer(p9345);
    }
  }
};